var _linearGradient, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebooklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ld6sqrtcxMyckEl6xeDdMa_uLWV5A9vXIPu_gr1",
    x1: 9.993,
    x2: 40.615,
    y1: 9.993,
    y2: 40.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ld6sqrtcxMyckEl6xeDdMa_uLWV5A9vXIPu_gr1)",
    d: "M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46 c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452 C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebooklogo);
export default __webpack_public_path__ + "static/media/facebooklogo.9d964eabbf83c1596f550d50caef9b30.svg";
export { ForwardRef as ReactComponent };